module.exports = __webpack_public_path__ + "static/media/plus.bf70d75b.svg";